import { isEmpty } from "lodash"
import { Redirect, Route, Switch } from "react-router-dom"
import { ProcessoSetorModel } from "../../../model/api/processo-setor/processo-setor-model"
import { KdsStorageKeys, useKdsStorage } from "../../../services/app"
import { MenuPrincipalProvider } from "../../../services/app/providers/menu-principal-provider"
import { NavegacaoProvider } from "../../../services/app/providers/navegacao-provider"
import { DialogProvider } from "../../../services/app/providers/dialog-provider"
import ConcluidosCanceladosPage from "../../../views/pages/private/concluidos-cancelados/concluidos-cancelados-page"
import { MainPage } from "../../../views/pages/private/main/main-page"
import MonitoramentoSetoresPage from "../../../views/pages/private/monitoramento/monitoramento-setores-page"
import PesquisaAvancadaPage from "../../../views/pages/private/pesquisa-avancada/pesquisa-avancada-page"
import SelecionarSetorPage from "../../../views/pages/private/selecionar-setor/selecionar-setor-page"
import LeitorComandaPage from "../../../views/pages/private/leitor-comanda/leitor-comanda-page"
import PedidoEntregaPage from "../../../views/pages/private/pedido-entrega/pedido-entrega-page"
import ConfirmarEntregaPage from "../../../views/pages/private/confirmar-entrega/confirmar-entrega-page"
import AssinaturaEntregaPage from "../../../views/pages/private/assinatura-entrega/assinatura-entrega-page"
import AdicionarPedidoEntregaPage from "../../../views/pages/private/adicionar-pedido-entrega/adicionar-pedido-entrega-page"
import { ModuloModel } from "../../../model/app/forms/master/modulo-model"
import { EnumModulo } from "../../../model/enums/enum-modulo"
import MotoboyPage from "../../../views/pages/private/motoboy/motoboy-page"
import { PullToRefreshContainer } from "../pull-to-refresh-container/pull-to-refresh-container"
import PedidosSemEntregadorPage from "../../../views/pages/private/pedidos-sem-entregador/pedidos-sem-entregador-page"

const RouterMain = () => {

    const { getRegistro } = useKdsStorage()

    const setores = getRegistro(KdsStorageKeys.ProcessosSetores, false) as ProcessoSetorModel[]
    const tipo = getRegistro(KdsStorageKeys.SelecaoModulo, false) as ModuloModel

    const retornaRotas = () => {
        if (isEmpty(tipo)) return '/'
        if (tipo.modulo === EnumModulo.KDS) return isEmpty(setores) ? '/selecionar-setor' : "/monitoramento"
        if (tipo.modulo === EnumModulo.Motoboy) return '/entregas-pendentes'

        return '/entrega'
    }

    return (
        <Switch>
            <PullToRefreshContainer>
                <DialogProvider>
                    <MenuPrincipalProvider>
                        <MainPage>
                            <NavegacaoProvider>
                                <Route exact path="/cancelados-concluidos" component={ConcluidosCanceladosPage} />

                                <Route exact path="/monitoramento" component={MonitoramentoSetoresPage} />

                                <Route exact path="/selecionar-setor" component={SelecionarSetorPage} />
                                <Route exact path="/ler-comanda" component={LeitorComandaPage} />
                                <Route exact path="/adicionar-pedido" component={AdicionarPedidoEntregaPage} />
                                <Route exact path="/entrega" component={PedidoEntregaPage} />
                                <Route exact path="/confirmar-entrega" component={ConfirmarEntregaPage} />
                                <Route exact path="/entregas-pendentes" component={MotoboyPage} />
                                <Route exact path="/assinatura" component={AssinaturaEntregaPage} />
                                <Route exact path="/pedidos-para-entrega/:pedidoId?" component={PedidosSemEntregadorPage} />
                                {/* <Route exact path="/selecionar-mesa" component={SelecionarMesaPage}
                            /> */}
                                <Route exact path="/">
                                    <Redirect to={retornaRotas()} />
                                </Route>
                                <Route exact path="/pesquisa-avancada" component={PesquisaAvancadaPage} />
                            </NavegacaoProvider>
                        </MainPage>
                    </MenuPrincipalProvider>
                </DialogProvider>
            </PullToRefreshContainer>
        </Switch>
    )
}

export default RouterMain